import React, { createElement } from "react"
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { isNull, isEqual, isArray } from "lodash";

import 'react-tabs/style/react-tabs.css';


import * as PD from '../classes/pdStyle';
import {cloneObject, getParam} from '../utils/utils';

import dsd from "../classes/clsDSD";


import ViewSolution from "../components/ViewSolution";
import ViewMetadata from "../components/ViewMetadata";
import ListRoles from "../components/ListRoles";
import ListSystems from "../components/ListSystems";
import ListCapabilities from "../components/ListCapabilities";
import ListParticipations from "../components/ListParticipations";

import Version from "../components/Version";
import ListVersions from "../components/ListVersions";
import ViewSolutionVersion from "../components/ViewSolutionVersion";


import { DesignerLayoutContext } from '../contexts/DesignerLayoutContext';
import Rendition from '../components/Rendition';


import Buffering from "../components/Buffering";
import D3Graphviz from "../components/D3Graphviz";

import JSZip from "jszip";

import {getSolution, editSolution, addSolution} from "../utils/utilsSolution";


import ViewVersion from "../components/ViewVersion";
import {zipSolution, assetsSolutionVersion} from "../utils/utilsSolution";
import { Reply } from "react-bootstrap-icons";



class Solution extends React.Component {

    static contextType = DesignerLayoutContext;

    constructor(props) {
        super(props);
        this.state = {
            mode: 'view',
            isLoaded: false,
            loadData:false
        };


        this.data = {};

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleMode = this.handleMode.bind(this);
        this.handleButton = this.handleButton.bind(this);
        this.handleVizClick = this.handleVizClick.bind(this);

        this.handleRoleFilters = this.handleRoleFilters.bind(this);
        this.handleSystemFilters = this.handleSystemFilters.bind(this);
        this.handleCapabilityFilters = this.handleCapabilityFilters.bind(this);
        this.handleParticipationFilters = this.handleParticipationFilters.bind(this);


        this.handleAddVersion = this.handleAddVersion.bind(this);
        this.VersionOnActioned = this.VersionOnActioned.bind(this);
        this.loadedVersions = this.loadedVersions.bind(this);

        this.handleExport = this.handleExport.bind(this);


        this.dsd = new dsd();
        this.dsd.StateObject = this;

        this.FallBackNavigation = `/solutions`;

    }

    componentDidMount(){

       this.setup();

    }


    componentDidUpdate(prevProps, prevState){

        if (!isEqual(this.props, prevProps)){
            this.setup();
        }


    }
    
    loadSolution(id){

        let StateChange = {};
        StateChange.Solution = null;

        const onLoad = function(data){
            let StateChange = {};
            StateChange.Solution = data;

            StateChange.FormData = data;

            StateChange.renderState = "loaded";
            StateChange.isLoaded = true;


            if (this.context.hasLayout){
                this.context.Layout.setLeftAsSolution(data._id);
            }


            StateChange.OfferEdit = false;
            try{
                if (this.dsd.loggedon){
                    if (StateChange.Solution.idUser == this.dsd.user.id){
                        StateChange.OfferEdit = true;
                    }
                }
            }
            catch{

            }   

            if (!StateChange.OfferEdit){
                switch (this.state.mode){
                    case "edit":
                    case "remove":
                        StateChange.renderState = "denied"
                        StateChange.errorMessage = "You cannot add or edit this Solution"
                    break;
                }
            }


            this.setState(StateChange);

            this.fetchViz(id);

            return;
        }.bind(this);

        const onFail = function(e){
            let StateChange = {};
            StateChange.Solution = null;
            StateChange.renderState = "failed";

            StateChange.errorMessage = e.message;    
            if (e.response){
                if (e.response.data){
                    if (e.response.data.message){
                        StateChange.errorMessage = e.response.data.message;
                    }
                }
            }
            this.setState(StateChange);
            return;
        }.bind(this);

        if (id){
            StateChange.renderState = "loading";
            getSolution(this.dsd, id,onLoad, onFail);
        }

        this.setState(StateChange);

        return;        
    };

    fetchViz(id) {

       const onDoneDot = function(dot) {
           this.setState({ dot: dot });
       }.bind(this);

       const onFailDot = function(error) {
           console.error('Failed to fetch DOT:', error);
       }.bind(this);

       getSolution(this.dsd, id, onDoneDot, onFailDot, 'dot', null, this.state.Controls);

   };

    async loadVersionAssets(id, idVersion){

        if (!id || idVersion == null){
            return;
        }

        this.setState({ renderState: 'loading' });

        const assets = await assetsSolutionVersion(this.dsd, id, idVersion);

        this.setState({
            mdVersionPage: assets["page.md"],
            VersionAssets: assets,
            isLoaded: true,
            renderState: 'loaded'
        });

        return;
        
    };


    setup(){


        let StateChange = {
            id: null,
            isLoaded: false,
            isUpdated: false,
            isFailed: false,
            loadData: false,

            idSolution: null,
            Solution: null,

            FormData: {},
            Controls: {
            },

            RoleFilters: {
                status:'in use'
            },

            SystemFilters: {
                status:'in use'
            },

            CapabilityFilters: {
                status:'in use'
            },

            ParticipationFilters: {
                status:'in use'
            },

            idVersion: null,
            countVersions: null,


            countRoles : null,
            countSystems : null,
            countParticipations: null,

            action: null,

            updateToggle: 0,

            vizNodeId: null,
            dot: null
        }

        StateChange.fallbackpath = `/solutions`;
        if (this.props.location.state){
            if (this.props.location.state.fallbackpath){
                StateChange.fallbackpath = this.props.location.state.fallbackpath;
            }
        }

        StateChange.mode = getParam('mode', this.props);
        StateChange.idSolution = getParam('id', this.props);

        StateChange.idVersion = getParam('idVersion', this.props);

        if (StateChange.mode == null){
            StateChange.mode = 'view';
        }


        this.setState(StateChange, async () => {

           if (this.state.idVersion){
               await this.loadVersionAssets(this.state.idSolution, this.state.idVersion);
               if (this.context.hasLayout){
                   this.context.Layout.setLeftAsSolutionVersions(this.state.idSolution);
               }
               return;
           }

            if (this.state.idSolution){
                this.loadSolution(this.state.idSolution);
            }

       });

        
    }

    handleChange(event) {

        const FormFieldName = event.target.name;
        let FormFieldValue = event.target.value;

        if (event.target.type == "checkbox"){
            FormFieldValue = event.target.checked;
        }

        let Controls = this.state.Controls;
        switch (FormFieldName){
            default:
                let FormData = this.state.FormData;
                FormData[FormFieldName] = FormFieldValue;        
                this.setState({"FormData": FormData});
                break;                
        }
        return;

    };
    
    handleRoleFilters(event) {

        const FormFieldName = event.target.name;
        let FormFieldValue = event.target.value;

        if (event.target.type == "checkbox"){
            FormFieldValue = event.target.checked;
        }

        let RoleFilters = this.state.RoleFilters;
        RoleFilters[FormFieldName] = FormFieldValue;
        this.setState({"RoleFilters": RoleFilters});

        return;

    };

    handleSystemFilters(event) {

        const FormFieldName = event.target.name;
        let FormFieldValue = event.target.value;

        if (event.target.type == "checkbox"){
            FormFieldValue = event.target.checked;
        }

        let SystemFilters = this.state.SystemFilters;
        SystemFilters[FormFieldName] = FormFieldValue;
        this.setState({"SystemFilters": SystemFilters});

        return;

    };

    handleCapabilityFilters(event) {

        const FormFieldName = event.target.name;
        let FormFieldValue = event.target.value;

        if (event.target.type == "checkbox"){
            FormFieldValue = event.target.checked;
        }

        let CapabilityFilters = this.state.CapabilityFilters;
        CapabilityFilters[FormFieldName] = FormFieldValue;
        this.setState({"CapabilityFilters": CapabilityFilters});

        return;

    };

    handleParticipationFilters(event) {

        const FormFieldName = event.target.name;
        let FormFieldValue = event.target.value;

        if (event.target.type == "checkbox"){
            FormFieldValue = event.target.checked;
        }

        let ParticipationFilters = this.state.ParticipationFilters;
        ParticipationFilters[FormFieldName] = FormFieldValue;
        this.setState({"ParticipationFilters": ParticipationFilters});

        return;

    };


    handleSubmit(event) {

        const onError = function(e){
            let StateChange = {};
            StateChange.renderState = "error";

            StateChange.errorMessage = e.message;

            if (e.response){
                if (e.response.data){
                    if (e.response.data.message){
                        StateChange.errorMessage = e.response.data.message;
                    }
                    if (e.response.data.fields){
                        for (const field in e.response.data.fields){
                            StateChange.invalidFields = e.response.data.fields
                        }
    
                    }
                }
            }
    
            this.setState(StateChange);
            return;
        }.bind(this);

        window.scrollTo(0, 0);

        switch (event.target.name){
            case 'btnCancel':

                switch (this.state.mode){
                    case 'new':
                        if (this.state.fallbackpath){
                            this.props.navigation(`${this.state.fallbackpath}`);
                        }
                        break;
                    case 'edit':
                        this.props.navigation(`/solution/${this.state.idSolution}`);
                        break;
        //            case 'remove':
        //                this.savviconfig.removeFactor(this.data.idProject,this.type,this.data.idFactor);
        //                break;  
                    default:
                        break; 
                };

                break;
            case 'btnSave':
            default:

                this.setState({
                    isUpdated: false,
                    isFailed: false,
                    invalidFields: false
                })
        
                switch (this.state.mode){
                    case 'new':
                        const onAdd = function(idSolution){
                            this.props.navigation(`/solution/${idSolution}`);
                            return;
                        }.bind(this);

                        addSolution(this.dsd, this.state.FormData, onAdd, onError);
                        break;
                    case 'edit':
                        const onUpdate = function(){
                            this.props.navigation(`/solution/${this.state.idSolution}`);
                            return;
                        }.bind(this);

                        editSolution(this.dsd, this.state.idSolution,this.state.FormData, onUpdate, onError);

                        break;
        //            case 'remove':
        //                this.savviconfig.removeFactor(this.data.idProject,this.type,this.data.idFactor);
        //                break;  
                    default:
                        break; 
                };
    
        };

        event.preventDefault();
    }

    handleMode(event) {
        this.setState({mode: event.target.value});
        event.preventDefault();
    }


    handleButton(event) {

        let StateChange = {};

        switch (event.target.name){
            case 'btnAddRole':
                this.props.navigation(`/solution/${this.state.idSolution}/role?mode=new`);
                break;
            case 'btnAddSystem':
                this.props.navigation(`/solution/${this.state.idSolution}/system?mode=new`);
                break;
            case 'btnAddCapability':
                this.props.navigation(`/solution/${this.state.idSolution}/capability?mode=new`);
                break;
            case 'btnAddParticipation':
                this.props.navigation(`/solution/${this.state.idSolution}/participation?mode=new`);
                break;
            
        }

        this.setState(StateChange);

        event.preventDefault();
    };

    handleAddVersion(event) {
        this.setState({newVersion:true});
    }



    handleVizClick(event) {

        let StateChange = {};

        let idNode = null;

        let target = null;
        if (event.target.tagName == "a"){
            target = event.target;
        } else{
            if ("parentElement" in event.target){
                if (event.target.parentElement.tagName == "a"){
                    target = event.target.parentElement;
                }
            }
        }

        if (target){
            if ("href" in target){
                idNode = target.href.baseVal;
                StateChange.vizNodeId = idNode;
            }
        }
        

        if (!idNode){
            return;
        }
        
        let partsVizNodeId = idNode.split('_');
        switch(partsVizNodeId[0]){
            case 'capability':
                if (partsVizNodeId.length > 1){
                    this.props.navigation(`/capability/${partsVizNodeId[1]}`);
                }
                break;
            case 'role':
                if (partsVizNodeId.length > 1){
                    this.props.navigation(`/role/${partsVizNodeId[1]}`);
                }
                break;
            case 'system':
                if (partsVizNodeId.length > 1){
                    this.props.navigation(`/system/${partsVizNodeId[1]}`);
                }
                break;
            case 'participation':
                if (partsVizNodeId.length > 1){
                    this.props.navigation(`/participation/${partsVizNodeId[1]}`);
                }
                break;
    
        }

        this.setState(StateChange);

        event.preventDefault();

    };

    versions(){

        if (!this.state.isLoaded){
            return null;
        }

        if (!this.state.Solution){
            return null;
        }

        let newVersion = false;
        let showAdd = false;

        if (this.state.OfferEdit){
            showAdd = true;
        }
        if (this.state.newVersion){
            showAdd = false;
            newVersion = true;
        }

        return (
            <div>
                {showAdd &&
                    <div style={{display:"flex"}}>
                        <PD.Button name='btnAdd' value='add a Named Version' onClick={this.handleAddVersion}/>
                    </div>
                }
                
                {newVersion &&
                    <Version mode='new' idAbout={this.state.idSolution} type='solution' onActioned={this.VersionOnActioned}/>
                }
                <ListVersions key={this.state.updateToggle} OfferEdit={this.state.OfferEdit} filters={{idAbout:this.state.idSolution}} onLoad={this.loadedVersions}/>

            </div>
        )
    }

    VersionOnActioned(){
       this.setState(
        {
            newVersion:false,
            updateToggle: Number(!this.state.updateToggle)
        })
    }

    loadedVersions(count){

        let StateChange = {};

        StateChange.countVersions = 0;
        if (count){
            StateChange.countVersions = count;
        }

        this.setState(StateChange);

    }

    async handleExport(event){

        this.setState({isExporting: true});
        try {
            let idSolution = this.state.idSolution;
            let idVersion = this.state.idVersion;
            let zipData = null;
            let link = null;

            zipData = await zipSolution(this.dsd, idSolution, idVersion);

            link = document.createElement("a");
            link.href = window.URL.createObjectURL(zipData);
            link.download = `solution_${idSolution}_version_${idVersion}.zip`;
            link.click();
        } finally {
            this.setState({isExporting: false});
        }
    }


    visualise(){
    
        if (!this.state.Solution){
            return <Buffering/>;
        }

        try {

            const images = this.dsd.getSolutionImages();

            return(
                <div>
                    <div name="divViz" onClick={this.handleVizClick}>
                        <D3Graphviz dot={this.state.dot} images={images}/>
                    </div>
                </div>
            );
          } catch (error) {
            return <div/>
          }
    };


    showError(){


        if (this.state.invalidFields){
            return(
                <>
                    {
                        Object.keys(this.state.invalidFields).map(
                        (field, pos) => 
                            {
                                let error = this.state.invalidFields[field].error;
                                return <p key={pos}>{field}:{error}</p>
                            }
                        )
                    }
                </>
            )
        }

        return "ERROR - Failed to Update";

    }


    render() {

        switch (this.state.renderState){
            case "invalid":
            case "failed":
            case "denied":
                let Message = "An error has occured";
                if (this.state.errorMessage){
                    Message = this.state.errorMessage;
                }
                return <PD.ErrorBox>{Message}</PD.ErrorBox>
                break;
            case "loading":
                return <Buffering/>
                break;
            case "cancelled":
                return <p>Cancelled</p>
                break;
    
        }

        if (this.state.idVersion){
            return(
                <div>
                    <PD.Button onClick={ () => this.props.navigation(`/solution/${this.state.idSolution}`) } value="back"><Reply/></PD.Button>
                    <PD.Button onClick={this.handleExport} name="btnExport" value={this.state.isExporting ? "" : "export"}>
                        {this.state.isExporting && <Buffering/>}
                    </PD.Button>
                    <ViewVersion mdPage={this.state.mdVersionPage} assets={this.state.VersionAssets} idVersion={this.state.idVersion}/>
                </div>
            )
        }


        switch (this.state.mode){
            case 'new':
            case 'edit':

                return (
                <div>

                    <PD.Heading>{this.state.mode} Solution</PD.Heading>

                    {this.state.isFailed &&
                        <PD.ErrorBox>{this.showError()}</PD.ErrorBox>
                    }

                    <form> 
                        <PD.Input label="Name" width="60" name="name" value={this.state.FormData.name} onChange={this.handleChange}/>

                        <PD.Editor label='Description' name="description" value={this.state.FormData.description} onChange={this.handleChange}/>

                        <PD.Editor label='Proposals' name="proposals" value={this.state.FormData.proposals} onChange={this.handleChange}/>

                        <PD.Select label="Status" name='status'  onChange={this.handleChange} value={this.state.FormData.status}>
                            {
                                this.dsd.config.ComponentStatuses.map(
                                    (status, posStatus) => 
                                        {
                                            return(
                                                <option key={posStatus} value={status}>{status}</option>
                                            )
                                        }
                                )
                            }
                        </PD.Select>

                        <PD.Button type="submit" onClick={this.handleSubmit} name="btnSave"value="Save" />    
                        <PD.Button type="warning" onClick={this.handleSubmit} name="btnCancel" value="Cancel" />    
                    </form>

                </div>    
                );
            case 'remove':
                return (
                    <div>
                        <PD.Heading>{this.state.mode} Solution</PD.Heading>

                        {this.state.isFailed &&
                            <PD.ErrorBox>ERROR - Failed to Update</PD.ErrorBox>
                        }

                        <PD.Button onClick={this.handleSubmit} type="warning" value="confirm remove?" />
                        <ViewSolution json={this.state.Solution}/>
                    </div>
                )
            case 'view':
            default:

                if (!this.state.Solution){
                    return <div/>
                }

                let countRoles = 0;
                if (this.state.Solution.Roles){
                    countRoles = this.state.Solution.Roles.length;
                }
                let countSystems = 0;
                if (this.state.Solution.Systems){
                    countSystems = this.state.Solution.Systems.length;
                }
                let countCapabilities = 0;
                if (this.state.Solution.Capabilities){
                    countCapabilities = this.state.Solution.Capabilities.length;
                }
                let countParticipations = 0;
                if (this.state.Solution.Participations){
                    countParticipations = this.state.Solution.Participations.length;
                }

                return (
                    <div>
                        <div>
                            <PD.Breadcrumb crumbs={this.Breadcrumb}/>
                            <PD.Heading>Solution:{this.state.Solution.name}</PD.Heading>
                        </div>

                        {this.state.OfferEdit &&
                            <span style={{paddingRight:10}}>
                                    <PD.Button onClick={this.handleMode} type="submit" value="edit" />                        
                            </span>
                        }

                        <ViewSolution Solution={this.state.Solution}/>

                        <br/>

                        <PD.Tabs>

                            <div label='Visualise'>
                                {this.visualise()}
                            </div>


                            <div label={`Roles(${countRoles})`}>
                                <div style={{display:"flex"}}>
                                    {this.state.OfferEdit && 
                                        <PD.Button name='btnAddRole' value='add a new Role' onClick={this.handleButton}/>
                                    }
                                    <fieldset style={{display:"flex"}}>
                                        <legend>filters</legend>
                                        <PD.Select label='status' name='status'  onChange={this.handleRoleFilters} value={this.state.RoleFilters.status}>
                                            {
                                                this.dsd.config.RoleStatuses.map(
                                                    (status, posStatus) => 
                                                        {
                                                            return(
                                                                <option key={posStatus} value={status}>{status}</option>
                                                            )
                                                        }
                                                )
                                            }
                                        </PD.Select>

                                    </fieldset>
                                </div>

                                <ListRoles filters={{idSolution:this.state.idSolution, ...this.state.RoleFilters}} parent={this} />

                            </div>

                            <div label={`Systems(${countSystems})`}>
                                <div style={{display:"flex"}}>
                                    {this.state.OfferEdit && 
                                        <PD.Button name='btnAddSystem' value='add a new System' onClick={this.handleButton}/>
                                    }
                                    <fieldset style={{display:"flex"}}>
                                        <legend>filters</legend>
                                        <PD.Select label='status' name='status'  onChange={this.handleSystemFilters} value={this.state.SystemFilters.status}>
                                            {
                                                this.dsd.config.SystemStatuses.map(
                                                    (status, posStatus) => 
                                                        {
                                                            return(
                                                                <option key={posStatus} value={status}>{status}</option>
                                                            )
                                                        }
                                                )
                                            }
                                        </PD.Select>

                                    </fieldset>
                                </div>

                                <ListSystems filters={{idSolution:this.state.idSolution, ...this.state.SystemFilters}} parent={this} />

                            </div>

                            <div label={`Capabilities(${countCapabilities})`}>
                                <div style={{display:"flex"}}>
                                    {this.state.OfferEdit && 
                                        <PD.Button name='btnAddCapability' value='add a new Capability' onClick={this.handleButton}/>
                                    }
                                    <fieldset style={{display:"flex"}}>
                                        <legend>filters</legend>
                                        <PD.Select label='status' name='status'  onChange={this.handleCapabilityFilters} value={this.state.CapabilityFilters.status}>
                                            {
                                                this.dsd.config.CapabilityStatuses.map(
                                                    (status, posStatus) => 
                                                        {
                                                            return(
                                                                <option key={posStatus} value={status}>{status}</option>
                                                            )
                                                        }
                                                )
                                            }
                                        </PD.Select>

                                    </fieldset>
                                </div>

                                <ListCapabilities filters={{idSolution:this.state.idSolution, ...this.state.CapabilityFilters}} parent={this} />

                            </div>



                            <div label={`Participations(${countParticipations})`}>
                                <div style={{display:"flex"}}>
                                    {this.state.OfferEdit && 
                                        <PD.Button name='btnAddParticipation' value='add a new Participation' onClick={this.handleButton}/>
                                    }
                                    <fieldset style={{display:"flex"}}>
                                        <legend>filters</legend>
                                        <PD.Select label='status' name='status'  onChange={this.handleParticipationFilters} value={this.state.ParticipationFilters.status}>
                                            {
                                                this.dsd.config.ParticipationStatuses.map(
                                                    (status, posStatus) => 
                                                        {
                                                            return(
                                                                <option key={posStatus} value={status}>{status}</option>
                                                            )
                                                        }
                                                )
                                            }
                                        </PD.Select>

                                    </fieldset>
                                </div>

                                <ListParticipations filters={{idSolution:this.state.idSolution, ...this.state.ParticipationFilters}} parent={this} />

                            </div>

                            <div label={<span>Versions({this.state.countVersions === null ? <Buffering/> : this.state.countVersions})</span>}  data-forcerender="true">
                                {this.versions()}
                            </div>
                            

                            <div label='Developer'>
                                <Rendition
                                    endpoint="/solutions"
                                    id={this.state.idSolution}
                                />
                            </div>

                            <div label='Metadata'>
                                <ViewMetadata Data={this.state.Solution} />
                            </div>


                        </PD.Tabs>


                    </div>
                )
        };


        return <div />;
    };
};

// Wrap and export
export default function Solution_wrapper(props) {
    
    const navigation = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <Solution {...props} navigation={navigation} location={location} params={params} />;
  }
